'use client'

import { toast } from '@/components/common/toast'
import { useTranslations } from 'next-intl'

interface FooterMenuMobileCopyItemProps {
  label: string
  gaTrackingValue: string
}

export const FooterMenuMobileCopyItem = ({
  label,
  gaTrackingValue,
}: FooterMenuMobileCopyItemProps) => {
  const t = useTranslations('footer')
  return (
    <button
      className='inline-block w-full text-left text-xs leading-5 text-neutral-300'
      onClick={() => {
        const copyText = label.includes(':') ? label.split(':').slice(1).join(':').trim() : label
        navigator.clipboard.writeText(copyText)
        toast.message({ title: t('copied') })
      }}
      ga-tracking-value={gaTrackingValue}
      ga-tracking-label={label}
    >
      {label}
    </button>
  )
}
